import { render } from "./EditPassword.vue?vue&type=template&id=774270e0&scoped=true"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"

import "./EditPassword.vue?vue&type=style&index=0&id=774270e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774270e0"]])

export default __exports__